<template>
    <div id="nav">
        <b-navbar
            toggleable="lg"
            type="dark"
            variant="primary"
            fixed="top"
        >
            <b-navbar-brand>
                <router-link
                    :to="{ name: 'home' }"
                    class="navbar-brand"
                >
                    PortalAsig<span class="d-none d-md-inline"> - Facultad de Ciencias</span>
                </router-link>

                <b-badge
                    v-if="isUserAdmin"
                    :to="{ name: 'admin'}"
                    variant="warning"
                    class="ml-1 p-2"
                >
                    Administrador
                </b-badge>
                <b-badge
                    v-if="isUserCoordInCurrentSite"
                    variant="success"
                    class="ml-3 p-2"
                >
                    Coordinador
                </b-badge>
                <b-badge
                    v-if="isUserProfInCurrentSite"
                    variant="dark"
                    class="ml-3 p-2"
                >
                    Docente
                </b-badge>
                <b-badge
                    v-if="isUserStudenTeacherInCurrentSite"
                    variant="light"
                    class="ml-3 p-2"
                >
                    Preparador
                </b-badge>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse" />

            <b-collapse
                id="nav-collapse"
                is-nav
            >
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-form class="d-none d-lg-flex">
                        <VueBootstrapTypeahead
                            v-if="coursesList"
                            placeholder="Buscar asignatura"
                            v-model.trim="courseQuery"
                            :maxMatches="5"
                            :data="coursesList"
                            :serializer="course => course.name"
                            @hit="goToLatestCourseSite($event)"
                        />
                    </b-nav-form>
                    <b-nav-item
                        v-if="!isUserAuthenticated"
                        :to="{ name: 'login' }"
                    >
                        Ingresar
                    </b-nav-item>
                    <b-nav-item-dropdown
                        id="user-dropdown-menu"
                        v-else
                        :text="getUserDisplayName"
                        menu-class="white-dropdown"
                        right
                    >
                        <b-dropdown-item :to="{ name: 'user-settings' }">Preferencias</b-dropdown-item>
                        <b-dropdown-item @click="onLogout">Salir</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'

export default {
    name: 'TheHeader',
    components: {
        VueBootstrapTypeahead
    },
    data () {
        return {
            courseQuery: ''
        }
    },
    computed: {
        ...mapState([
            'coursesList'
        ]),
        ...mapGetters([
            'isUserAuthenticated',
            'getUserDisplayName',
            'isUserAdmin',
            'isUserCoordInCurrentSite',
            'isUserProfInCurrentSite',
            'isUserStudenTeacherInCurrentSite'
        ])
    },
    methods: {
        ...mapActions([
            'logOut'
        ]),
        async onLogout () {
            const userDisplayName = JSON.parse(JSON.stringify(this.getUserDisplayName))

            await this.logOut().catch(err => {
                console.log(err)
                this.$root.unknownErrorToast()
            })
            this.$root.infoToast(`Hasta luego ${userDisplayName}.`, 'Cierre de sesión exitoso.')
            if (this.$route.name !== 'home') {
                this.$router.replace({ name: 'home' })
            }
        },
        goToLatestCourseSite (course) {
            if (course.sites.length) {
                // Nagivate to the latests site for the chosen course
                this.courseQuery = '' // Reset the typeahead input string
                var academicPeriod = course.sites[course.sites.length - 1].semester.academic_period
                this.$router.push({ name: 'site', params: { courseCode: course.code, academicPeriod: academicPeriod } })
            } else {
                this.$root.warningToast(`La asignatura ${course.name} no posee sitio asociado.`, 'No posee sitio.')
            }
        }
    }
}
</script>
